import EditTimeoffRequestModal from './EditTimeoffRequestModal.container';

export default EditTimeoffRequestModal;
